import { SlidersHorizontal } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * discover-chrome-density — le filtre s'ouvre depuis le HEADER, sur la ligne du
 * titre de page.
 *
 * Il occupait une rangée à lui seul sous le sélecteur de cercles : 38 pt pris à
 * une carte qui débordait déjà par le haut, au point de rogner la pochette du
 * son. Remonté ici, il ne coûte plus rien en hauteur.
 *
 * Il porte le NOMBRE de styles actifs, jamais leurs emojis. Les emojis sont plus
 * informatifs et c'est précisément le problème : leur largeur suit la sélection,
 * donc le titre de la page se raccourcirait en filtrant et se rallongerait en
 * décochant. Un titre qui respire au rythme d'un filtre, c'est le détail qu'on
 * ne sait pas nommer mais qui fait « pas fini ».
 */
export default function StyleFilterTrigger({
  count,
  onOpen,
  label,
}: {
  /** Nombre de styles sélectionnés. 0 = aucun filtre. */
  count: number;
  onOpen: () => void;
  /** Libellé accessible — le bouton est visuellement muet. */
  label: string;
}) {
  const active = count > 0;

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={label}
      data-testid="style-filter-trigger"
      className={cn(
        // Boîte de taille FIXE : seul le contenu change, jamais les dimensions —
        // sinon le titre voisin se tronquerait au rythme de la sélection.
        'tw:flex tw:h-10 tw:min-w-10 tw:shrink-0 tw:items-center tw:justify-center tw:gap-1 tw:rounded-full tw:px-2 tw:transition-opacity tw:active:opacity-70',
        active ? 'tw:bg-blue-primary tw:text-white' : 'tw:btn-circle tw:text-white',
      )}
    >
      <SlidersHorizontal size={18} />
      {active && <span className="tw:text-[13px] tw:font-semibold">{count}</span>}
    </button>
  );
}
